import React from 'react';
import { GenericDialog } from 'app/components/Alerts/GenericDialog';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

export const WorkExperienceDialog = ({
  open,
  children,
  setDialogOpen,
  handleProceed,
}: {
  open: boolean;
  children?: JSX.Element;
  setDialogOpen: Function;
  handleProceed?: any;
}) => {
  const { t } = useTranslation();

  return (
    <GenericDialog
      open={open}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
      onClose={(e, reason) => {
        if (reason === 'backdropClick') return;
        setDialogOpen(false);
      }}
      dialogTitleProps={{
        style: { paddingTop: '20px' },
        text: t('deleteModal.deleteConfirmationMsg'),
      }}
      dialogActions={[
        {
          text: 'Cancel',
          color: 'tertiary',
          variant: 'contained',
          onClick: () => {
            setDialogOpen(false);
          },
        },
        {
          text: t('cancelModal.confirmation.OK'),
          variant: 'contained',
          color: 'primary',
          onClick: () => handleProceed(),
          disabled: false,
        },
      ]}
    >
      <Typography style={{ color: '#707070', fontSize: '16px' }}>
        {t('candidate.workExperience.workExperienceGrid.deleteWorkExpRecord')}
      </Typography>
    </GenericDialog>
  );
};
